import React, { useEffect, useRef, useState } from "react";
import { Currencies } from "@tootsweet/model/enums/Currencies";

interface CurrencySelectorProps {
  value: string;
  onChange: (currency: string) => void;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (currency: string) => {
    props.onChange(currency);
    setIsOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      style={{
        position: "relative",
        display: "inline-block",
        width: "100%",
        zIndex: 2000
      }}
    >
      <div className="kc-input-wrapper">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="kc_input pl-3"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            zIndex: 2000
          }}
        >
          <span>{props.value}</span>
          <span
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease"
            }}
          >
            ▼
          </span>
        </div>
      </div>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "4px",
            background: "white",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            width: "100%",
            zIndex: 1000,
            maxHeight: "300px",
            overflowY: "auto"
          }}
        >
          {Object.values(Currencies).map((currency) => (
            <div
              key={currency}
              onClick={() => handleSelect(currency)}
              className="p-4 cursor-pointer"
              style={{
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: props.value === currency ? "#f5f5f5" : "white",
                transition: "background-color 0.2s ease"
              }}
              onMouseEnter={(e) => {
                if (props.value !== currency) {
                  e.currentTarget.style.backgroundColor = "#fafafa";
                }
              }}
              onMouseLeave={(e) => {
                if (props.value !== currency) {
                  e.currentTarget.style.backgroundColor = "white";
                }
              }}
            >
              {currency}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;
